const ResponseStatus = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR"
};
export default ResponseStatus;
